import React from 'react';
import { I18nextProvider } from 'react-i18next';
import { AuthProvider } from 'react-oidc-context';
import i18next from 'i18next';
import { createRoot } from 'react-dom/client';
import { AuthProvider as CustomAuthProvider } from '@/contexts/AuthContext';
import { oidcConfig } from '@/helpers/authUtils';
import { defaultLanguage } from '@/helpers/constants';
import { getAppLanguage } from '@/helpers/utils';
import { ClearCacheProvider } from '@/hooks/ClearCache';
import commonDe from '@/i18n/de/common';
import commonEn from '@/i18n/en/common';
import App from './App';
import * as serviceWorker from './serviceWorker';
import './index.css';

i18next.init({
  interpolation: { escapeValue: false },
  lng: getAppLanguage(),
  fallbackLng: defaultLanguage,
  resources: {
    en: {
      common: commonEn,
    },
    de: {
      common: commonDe,
    },
  },
  defaultNS: 'common',
  returnNull: false,
});

const container = document.getElementById('root');
const root = createRoot(container!);

root.render(
  <ClearCacheProvider>
    <I18nextProvider i18n={i18next}>
      <AuthProvider {...oidcConfig}>
        <CustomAuthProvider>
          <App />
        </CustomAuthProvider>
      </AuthProvider>
    </I18nextProvider>
  </ClearCacheProvider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
